import { useSyncExternalStore } from "react";

import { BREAKPOINT_SIZES } from "@constants";

export type HaNLayoutMode = "mobile" | "medium" | "wide";

// Tailwind's `sm` and `lg` screens come from the same sizes, so CSS and this hook switch layouts at the same width
const MEDIUM_QUERY = `(min-width: ${BREAKPOINT_SIZES.small}px)`;
const WIDE_QUERY = `(min-width: ${BREAKPOINT_SIZES.large}px)`;

const getLayoutMode = (): HaNLayoutMode => {
  if (window.matchMedia(WIDE_QUERY).matches) return "wide";
  if (window.matchMedia(MEDIUM_QUERY).matches) return "medium";

  return "mobile";
};

const subscribe = (onChange: () => void) => {
  const mediaQueries = [MEDIUM_QUERY, WIDE_QUERY].map(query => window.matchMedia(query));

  mediaQueries.forEach(mediaQuery => mediaQuery.addEventListener("change", onChange));

  return () => {
    mediaQueries.forEach(mediaQuery => mediaQuery.removeEventListener("change", onChange));
  };
};

/** Which of H&N's three layouts applies. Only for what CSS can't do, like whether a part exists at all. */
export const useHaNLayoutMode = () => {
  return useSyncExternalStore(subscribe, getLayoutMode);
};
